export default {
  logoCliente: null,
  escritorio: null,
  tipoDeAcesso: null,
  temAcessoAoFinanceiro: false,
  financeiroContratado: false,
  temAcessoAosRelatorios: false,
  temAcessoAoFaturamento: false,
  temAcessoAoEscritorio: false,
  faturamentoContratado: false,
  relatoriosContratado: false,
  nomeUsuarioLogado: null,
  codigoFotoUsuario: null,
  perfilUsuario: null,
  escritorioInadimplente: false,
  loginStrategy: null,
  regrasLogin: null,
  representanteLegal: false,
  nomeEmpresa: null,
  idEmpresa: null,
  cpfCnpj: null,
  emailUsuario: null,
  dadosAlertaVencimento: null,
  dadosAlertaDesbloqueio: null,
  idUsuarioLogado: null,
  dataCriacaoUsuarioLogado: null,
  suporteOnlineHabilitado: false,
  dadosCampanhaMarketing: [],
  ocultarOpcaoMenuBanco: false,
  alertaStatusEmpresa: null
}
